class StepMiniPedagogicalApproachService {
    constructor($http, $state, $q, $stateParams) {
        let self = this;
        this.$http = $http;
        this.$q = $q;
        this.$stateParams = $stateParams;

        this.saveDataConfig = (questions, summary, fromParams = null) => {
            return self.$http({
                method: "POST",
                url: `/api/mini/${self.$stateParams.id}/pedagogical_approach`,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {
                    items: Object.values(questions).map(e => ({
                        question: e.id,
                        hidden: !!e.hidden,
                        strength: e.strength,
                        developmentArea: e.developmentArea,
                        magnifyingGlass: !isNaN(e.magnifyingGlass) ? e.magnifyingGlass : null,
                        pin: !isNaN(e.pin) ? e.pin : (!isNaN(e.magnifyingGlass) ? e.magnifyingGlass : null)
                    })),
                    strengths: summary.strengths ? summary.strengths : '',
                    strengthsImage: summary.strengthsImage ? summary.strengthsImage : '',
                    developmentAreas: summary.developmentAreas ? summary.developmentAreas : '',
                    developmentAreasImage: summary.developmentAreasImage ? summary.developmentAreasImage : '',
                    ignoredQuestions: questions.filter(e => e.hidden),
                    param: fromParams ? +fromParams.activeParameter : +self.$stateParams.activeParameter
                }
            }).then((res => res.data), (error) => self.$q.reject(error));
        };

        this.saveExportData = (exportData, evaluationId) => {
            return self.$http({
                method: "POST",
                url: `/api/mini/${evaluationId}/pedagogical_approach_summary`,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: exportData
            }).then((res => res.data), (error) => self.$q.reject(error));
        };
    };
}

export default StepMiniPedagogicalApproachService;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/services/stepMiniPedagogicalApproachService.js